// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_jt-0";
export var animationContainer = "_jt-1";
export var itemPrice = "_jt-a";
export var itemizedContent = "_jt-9";
export var itemizedHeader = "_jt-7";
export var itemizedRow = "_jt-8";
export var itemizedSection = "_jt-6";
export var modalContent = "_jt-2";
export var orderName = "_jt-3";
export var refundOption = "_jt-4";
export var refundOptionsContainer = "_jt-5";
export var shippingLabel = "_jt-b";
export var totalRow = "_jt-c";